const navbar = {
  packages: "パッケージ", // translated
  hotelPackages: "ホテルパッケージ", // translated
  experiences: "体験談", // translated
  close: "近い", // translated
  hotDeals: "人気のセール", // translated
  dashboard: "ダッシュボード", // translated
  pricing: "価格設定", // translated
};


export default navbar;
